var map = {
	"./colorPicker.json": "2a73",
	"./common.json": "8a66",
	"./commonPage.json": "5620",
	"./commonProduct.json": "e567",
	"./filemanager.json": "6817",
	"./floatframeTool.json": "a05f",
	"./manageAppearance.json": "5b60",
	"./manageFooter.json": "796e",
	"./manageForm.json": "96d0",
	"./manageGridCell.json": "9c8d",
	"./manageHeader.json": "a0aa",
	"./manageHtml.json": "1b08",
	"./manageMobile.json": "2ae5",
	"./manageMobileGridLayout.json": "fa42",
	"./managePage.json": "96d8",
	"./manageQuotationForm.json": "36de5",
	"./manageSection.json": "ffe9",
	"./manageSectionDivider.json": "b5b3",
	"./manageSectionPageAlbum.json": "aee8",
	"./manageSectionPageAlbumItem.json": "49eb",
	"./manageSectionPageContact.json": "fd47",
	"./manageSectionPageContent.json": "9a66",
	"./manageSectionPageContentItem.json": "c8d6",
	"./manageSectionPageEventCalendar.json": "a279",
	"./manageSectionPageEventCalendarDetail.json": "a094",
	"./manageSectionPageForm.json": "f291",
	"./manageSectionPageGiftcard.json": "136c",
	"./manageSectionPageProduct.json": "4477",
	"./manageSectionPageProductBrand.json": "abdc",
	"./manageSectionPageProductDetail.json": "b426",
	"./manageSectionPageQuotationForm.json": "b594",
	"./manageSocial.json": "ed20",
	"./manageText.json": "aa28",
	"./manageTextAnimation.json": "deeb",
	"./modalAddLink.json": "2b8f",
	"./modalCannotAddWidgetInSlide.json": "b87a",
	"./modalFontAwesome.json": "9daa",
	"./modalSingleEdit.json": "e37b",
	"./modalWelcome.json": "0671",
	"./sidebar.json": "7762",
	"./sidebarAddWidget.json": "b5b5",
	"./sidebarFooterWidget.json": "b776",
	"./sidebarNavigation.json": "32a9",
	"./sidebarSectionTitle.json": "b8af",
	"./sidebarSlideSection.json": "3569",
	"./sidebarTitle.json": "1176",
	"./sidebarWidgetButton.json": "beab",
	"./sidebarWidgetContact.json": "1822",
	"./sidebarWidgetContent.json": "b357",
	"./sidebarWidgetCounter.json": "54c2",
	"./sidebarWidgetCoupon.json": "0a9e",
	"./sidebarWidgetEventCalendar.json": "d83c",
	"./sidebarWidgetFAQ.json": "2e55",
	"./sidebarWidgetGiftcard.json": "e46b",
	"./sidebarWidgetHtml.json": "221e",
	"./sidebarWidgetImage.json": "ab86",
	"./sidebarWidgetImageAlbum.json": "322b",
	"./sidebarWidgetImageGallery.json": "945c",
	"./sidebarWidgetInstagramFeed.json": "937f",
	"./sidebarWidgetInteractive.json": "38d1",
	"./sidebarWidgetLineSeparate.json": "8236",
	"./sidebarWidgetMap.json": "97df",
	"./sidebarWidgetMenuProduct.json": "7e34",
	"./sidebarWidgetProduct.json": "58b4",
	"./sidebarWidgetProductBrand.json": "1b80",
	"./sidebarWidgetProductCategory.json": "a9b4",
	"./sidebarWidgetSlide.json": "2026",
	"./sidebarWidgetSocial.json": "df70",
	"./sidebarWidgetTable.json": "afea",
	"./sidebarWidgetTiktok.json": "4634",
	"./sidebarWidgetTitle.json": "1977",
	"./sidebarWidgetYoutube.json": "9ce2",
	"./toolBackground.json": "5550",
	"./toolButtonSetting.json": "07b7",
	"./topbar.json": "5b00",
	"./widgetContact.json": "f306",
	"./widgetHtml.json": "5dce",
	"./widgetImage.json": "765f",
	"./widgetInteractive.json": "edf0",
	"./widgetYoutube.json": "e7a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4763";